import React, { useState } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import moment from 'moment';

// Utility function to get IP for group
const getIPForGroup = (groupId) => {
  // Map groupId to IP
const groupToIP = {
  1: 'https://barkasayal.cclai.in', 2: 'https://argada.cclai.in', 3: 'https://nk.cclai.in', 4: 'https://bk.cclai.in', 5: 'https://kathara.cclai.in', 6: 'https://giridih.cclai.in', 7: 'https://amrapali.cclai.in', 8: 'https://magadh.cclai.in', 9: 'https://rajhara.cclai.in', 10: 'https://kuju.cclai.in', 11: 'https://hazaribagh.cclai.in', 12: 'https://rajrappa.cclai.in', 13: 'https://dhori.cclai.in', 14: 'https://piparwar.cclai.in',
};

return groupToIP[groupId] || '202.140.131.94:5050'; // Default to Barka Sayal if not found

};

// API function to send report - modified to handle pagination and limit to 500 events
const sendReport = async (ip, params) => {
  try {
    // First get total count
    const countResponse = await fetch(`https://${ip}/api/va/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        deviceId: params.deviceId,
        locationType: params.locationType,
        from: params.from,
        to: params.to,
        eventTypes: params.eventTypes,
        page: 1,
        perPage: 1
      }),
    });
    
    if (!countResponse.ok) throw new Error('Failed to get event count');
    const countData = await countResponse.json();
    const totalCount = countData.total || 0;
    
    // Cap the perPage to 500 even if there are more events
    const updatedParams = {
      ...params,
      perPage: Math.min(totalCount, 500)
    };
    
    const response = await fetch(`https://${ip}/va/sendReport`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updatedParams),
    });
    
    if (!response.ok) throw new Error('Please contact your administrator');
    return { 
      ...response.json(), 
      totalCount 
    }; // Return total count along with response
  } catch (error) {
    console.error('Error in sendReport:', error);
    throw error;
  }
};

// Get all group IDs based on area selection
const getGroupIds = (areas) => {
  const areaToGroupId = {
  'Barka Sayal': 1,
  'Argada': 2,
  'North Karanpura': 3,
  'Bokaro & Kargali': 4,
  'Kathara': 5,
  'Giridih': 6,
  'Amrapali & Chandragupta': 7,
  'Magadh & Sanghmitra': 8,
  'Rajhara': 9,
  'Kuju': 10,
  'Hazaribagh': 11,
  'Rajrappa': 12,
  'Dhori': 13,
  'Piparwar': 14
};

  // If areas includes "All" or is empty, return all group IDs
  if (!areas || areas.includes("All")) {
    return Object.values(areaToGroupId);
  }
  
  // Return an array of group IDs for the selected areas
  return areas.map(area => areaToGroupId[area] || 12).filter(id => id);
};

const SendWhatsAppReport = ({ open, onClose, selectedAreas, timeFilter, selectedDetection, selectedLocationTypes }) => {
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [period, setPeriod] = useState('custom');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [progress, setProgress] = useState(0);

  // Map app detection types to API detection types
  const getEventTypes = (detectionType) => {
    const appToApiMap = {
      'cd': 'CD',
      'pd': 'PD',
      'vd': 'VD',
      'vc': 'VC',
      'ls': 'LS',
      'us': 'US'
    };
    
    if (detectionType && appToApiMap[detectionType]) {
      return [appToApiMap[detectionType]];
    }
    
    // Default to all types
    return ['CD', 'PD', 'VD', 'VC', 'LS', 'US'];
  };

  const handleSendReport = async () => {
    if (!whatsappNumber) {
      setError('Please enter a WhatsApp number');
      return;
    }
    
    setIsLoading(true);
    setError(null);
    setSuccess(null);
    setProgress(0);
    
    try {
      let selectedFrom;
      let selectedTo;
      
      switch (period) {
        case 'today':
          selectedFrom = moment().startOf('day');
          selectedTo = moment().endOf('day');
          break;
        case 'yesterday':
          selectedFrom = moment().subtract(1, 'day').startOf('day');
          selectedTo = moment().subtract(1, 'day').endOf('day');
          break;
        case 'thisWeek':
          selectedFrom = moment().startOf('week');
          selectedTo = moment().endOf('week');
          break;
        default:
          selectedFrom = moment(timeFilter.startTime);
          selectedTo = moment(timeFilter.endTime);
          break;
      }
      
      // Calculate number of days between dates
      const noOfDays = selectedTo.diff(selectedFrom, 'days');
      
      if (noOfDays > 30) {
        setError('Time range should be less than 30 days');
        setIsLoading(false);
        return;
      }
      
      // Get all group IDs based on area selection
      const groupIds = getGroupIds(selectedAreas);
      const eventTypes = getEventTypes(selectedDetection);
      
      // For each group ID, send a report
      let successCount = 0;
      const totalGroups = groupIds.length;
      let totalEvents = 0;
      let wasLimited = false;
      
      
      const groupIdToArea = {
  1: 'Barka Sayal',
  2: 'Argada',
  3: 'North Karanpura',
  4: 'Bokaro & Kargali',
  5: 'Kathara',
  6: 'Giridih',
  7: 'Amrapali & Chandragupta',
  8: 'Magadh & Sanghmitra',
  9: 'Rajhara',
  10: 'Kuju',
  11: 'Hazaribagh',
  12: 'Rajrappa',
  13: 'Dhori',
  14: 'Piparwar'
};
      
      for (let i = 0; i < groupIds.length; i++) {
        const groupId = groupIds[i];
        const ip = getIPForGroup(groupId);
        
        // Find area name from group ID
        const areaName = groupIdToArea[groupId] || "Unknown";
        
        // Set area name for the report
        const areaParam = !selectedAreas || selectedAreas.includes("All")
          ? `${areaName} (All Areas Report)`
          : areaName;
        
        // Get location type values
        let locationTypeValues = ["ALL"];
        if (selectedLocationTypes && !selectedLocationTypes.includes("All")) {
          // Map the location types to their API values if needed
          locationTypeValues = selectedLocationTypes;
        }
        
        // Prepare parameters
        const params = {
          deviceId: 0, // Fetch all devices
          groupId,
          locationType: locationTypeValues,
          from: selectedFrom.toISOString(),
          to: selectedTo.toISOString(),
          eventTypes,
          whatsappNumber,
          page: 1,
          perPage: 500, // Initial setting, will be capped if needed
          sort: "DESC",
          reportType: !selectedAreas || selectedAreas.includes("All") ? "all" : "single",
          areaName: areaParam,
          timeRange: {
            start: selectedFrom.format('YYYY-MM-DD HH:mm:ss'),
            end: selectedTo.format('YYYY-MM-DD HH:mm:ss')
          }
        };
        
        try {
          // Send report
          const result = await sendReport(ip, params);
          
          // Check if the report was limited
          if (result.totalCount > 500) {
            wasLimited = true;
            totalEvents += result.totalCount;
          }
          
          successCount++;
        } catch (err) {
          console.error(`Error sending report for ${areaName}:`, err);
          // Continue with other areas
        }
        
        // Update progress
        setProgress(Math.round(((i + 1) / totalGroups) * 100));
      }
      
      if (successCount > 0) {
        let message = `Report sent successfully to ${successCount} out of ${totalGroups} area(s)`;
        if (wasLimited) {
          message += ` (Limited to top 500 events per area)`;
        }
        setSuccess(message);
      } else {
        setError('Failed to send report to any area. Please try again.');
      }
    } catch (error) {
      console.error('Error sending report:', error);
      setError(error.message || 'Failed to send report. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Send Report to WhatsApp</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {error && (
            <Typography color="error" variant="body2" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success.main" variant="body2" sx={{ mb: 2 }}>
              {success}
            </Typography>
          )}
          
          <TextField
            label="WhatsApp Number"
            placeholder="Enter WhatsApp number with country code"
            fullWidth
            margin="normal"
            value={whatsappNumber}
            onChange={(e) => setWhatsappNumber(e.target.value)}
            // helperText="Example: +917012345678"
          />
          
          <FormControl fullWidth margin="normal">
            <InputLabel>Time Period</InputLabel>
            <Select
              value={period}
              onChange={(e) => setPeriod(e.target.value)}
              label="Time Period"
            >
              <MenuItem value="custom">Custom (Selected Date Range)</MenuItem>
              {/* <MenuItem value="today">Today</MenuItem>
              <MenuItem value="yesterday">Yesterday</MenuItem>
              <MenuItem value="thisWeek">This Week</MenuItem> */}
            </Select>
          </FormControl>
          
          {period === 'custom' && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2">
                From: {moment(timeFilter.startTime).format('MMMM D, YYYY, h:mm A')}
              </Typography>
              <Typography variant="body2">
                To: {moment(timeFilter.endTime).format('MMMM D, YYYY, h:mm A')}
              </Typography>
            </Box>
          )}
          
          {isLoading && (
            <Box sx={{ width: '100%', mt: 2 }}>
              <Typography variant="body2">{`Progress: ${progress}%`}</Typography>
              <Box sx={{ width: '100%', bgcolor: '#e0e0e0', borderRadius: 1, mt: 1 }}>
                <Box
                  sx={{
                    width: `${progress}%`,
                    bgcolor: '#1ABC9C',
                    height: 10,
                    borderRadius: 1,
                  }}
                />
              </Box>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Cancel
        </Button>
        <Button 
          onClick={handleSendReport} 
          variant="contained" 
          color="primary"
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={24} /> : 'Send Report'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendWhatsAppReport;